import React, { Component } from "react";
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Label
} from "reactstrap";
import moment from "moment";

import Registry from "../../../Utils/Registry";
import Helpers from "../../../Utils/Helpers";


class OperationsOrdersCancelModal extends Component{
    constructor(props){
        super(props);

        this.postRequest = this.postRequest.bind(this);
        this.cancelRequest = this.cancelRequest.bind(this);
        this.toggle = this.toggle.bind(this);
        this.messageChanged = this.messageChanged.bind(this);

        this.api = Registry.registered("api");

        this.state = {
            isOpen: this.props.isOpen,
            message: ""
        }
    }

    postRequest(){
        this.props.onValidate();
        this.api.put("/orders/" + this.props.order.id + "/requestCancel?is_business=1", {
            comment: this.state.message
        })
            .then(results => {
                this.setState({isOpen: false});
                this.props.onRequestMade();
            });
    }

    cancelRequest(){
        this.setState({isOpen: false}, () => {
            this.props.onRefuse();
        });
    }

    messageChanged(e){
        this.setState({message: e.target.value});
    }

    toggle(){
        this.setState({isOpen: !this.state.isOpen, message: ""}, () => {
            if(!this.state.isOpen)
                this.props.onRefuse();
        });
    }

    render(){
        return (
            <Modal isOpen={this.state.isOpen} toggle={this.toggle}>
                {
                    this.props.title ?
                        <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
                        : ""
                }
                <ModalBody>
                    <div className="ty-block bg-gray_light-important pad-15 blue_dark">
                        <Row>
                            <Col md="12">
                                <div className="bold text-uppercase blue_dark">Informations livraison</div>
                                <div className="marg-t-10">
                                    { this.props.order.business_name ? this.props.order.business_name + " par " : "" }
                                    { this.props.order.customer_first_name + " " + this.props.order.customer_last_name }<br />
                                    { this.props.order.location }<br />
                                    { Helpers.formatDate(this.props.order.start_datetime) }
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <ul className="list-unstyled marg-t-15 marg-b-0">
                                    {
                                        this.props.order.vehicles.map((vehicle, i) => {
                                            return (
                                                <li key={i} className="f-12">
                                                    {
                                                        vehicle.description + " " +
                                                        vehicle.color + " - " +
                                                        vehicle.plate
                                                    }
                                                </li>
                                            );
                                        })
                                    }
                                </ul>
                            </Col>
                        </Row>
                    </div>

                    <div className="marg-t-20">
                        <Label className="bold">
                            Votre message
                        </Label>
                        <Input
                            type="textarea"
                            className="marg-b-0"
                            rows={6}
                            value={this.state.message}
                            onChange={this.messageChanged}
                            placeholder="Details de votre annulation ..."
                        />
                    </div>
                </ModalBody>
                <ModalFooter className="center">
                    <Button className="text-uppercase" size="" color="secondary" onClick={this.cancelRequest}>Annuler</Button>{' '}
                    <Button className="text-uppercase" size="" color="primary" onClick={this.postRequest}>Envoyer</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

OperationsOrdersCancelModal.defaultProps = {
    title: "Annuler ma commande",
    isOpen: false,
    onValidate: () => {},
    onRefuse: () => {},
    onRequestMade: () => {},
    order: {
        id: false,
        location: "",
        vehicles: [],
        start_datetime: ""
    }
};

export default OperationsOrdersCancelModal;



// WEBPACK FOOTER //
// ./src/components/Operations/Orders/CancelModal.js